import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "bridgetown-quick-search"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { register as registerNav } from "./nav"
import { register as registerHowItWorks } from "./how_it_works"

const modules = [
  registerNav,
  registerHowItWorks,
]

document.addEventListener("DOMContentLoaded", () => {
  modules.forEach((register) => register())
})
